<template lang="html">
  <v-app class="large-screen__body white">
    <v-btn icon class="browse__close-icon" :to="{name: 'Tasks'}">
      <v-icon>close</v-icon>
    </v-btn>
    <div class="div-container body">
      <div class="title--txt">
        Choose at least 4 interests areas to proceed
      </div>
      <div class="welcome-txt mt-40">
        <div class="mt-64">
          <v-container fluid class="pa-0">
            <!-- <v-layout row wrap class="input-container mb-24">
              <v-flex xs12 sm12 class="pa-0">
                <v-select
                  solo
                  multiple
                  cache-items
                  autocomplete
                  class="select"
                  placeholder="Type to search for skills"
                  :items="interests"
                  item-text="interest_name"
                  item-value="interest_id"
                  v-model="userInterests"
                >
                </v-select>
              </v-flex>
            </v-layout> -->
            <v-layout row wrap class="mb-24 interests-layout">
              <template v-for="item in interests">
                <div class="interests-container" :class="{ 'active': selectedInterests(item) }" @click="addRemoveInterests(item)">
                  {{ item.interest_name }}
                </div>
              </template>
            </v-layout>
          </v-container>
        </div>
      </div>
    </div>

    <div class="action-button">
      <v-btn
        large
        class="fixed-primary-button white--text"
        :disabled="this.userInterests.length < 4"
        @click="submitInterests()"
      >
        Proceed
      </v-btn>
    </div>
  </v-app>
</template>

<script>

export default {
  data() {
    return {
      userInterests: [],
    };
  },
  computed: {
    browseId() {
      return this.$store.getters['browseTasks/browseId'];
    },
    interests() { return this.$store.getters['browseTasks/interests']; },
  },
  methods: {
    submitInterests() {
      const params = { browse_id: this.browseId, browse_interests: this.userInterests };
      this.$store
        .dispatch('browseTasks/browseTaskEdit', params)
        .then(() => {
          this.$router.push({ name: 'Tasks', query: { browse_id: this.browseId } });
        });
    },
    selectedInterests(item) {
      for (let i = 0; i < this.userInterests.length; i += 1) {
        if (this.userInterests[i].interest_id === item.interest_id) {
          return true;
        }
      }
      return false;
    },
    addRemoveInterests(item) {
      for (let i = 0; i < this.userInterests.length; i += 1) {
        if (this.userInterests[i].interest_id === item.interest_id) {
          if (i > -1) {
            this.userInterests.splice(i, 1);
            return;
          }
        }
      }
      // if interest is not present push it in userInterests
      this.userInterests.push({ interest_id: item.interest_id });
    },
  },
  mounted() {
    this.$store.dispatch('browseTasks/getBrowseTaskInterests');
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";
#app {
  input {
    width: 100%;
  }
  .mt-40{
    margin-top: 40px;
  }
  .proceed-button {
    border-radius: 24px;
    background: $primary;
    font-family: MuseoSans-900;
    font-size: 16px;
    padding-left: 14px;
    padding-right: 14px;
    position: relative;
  }
  .button-container {
    position: fixed;
    bottom: 82px;
    text-align: center;
    cursor: not-allowed;
  }

  .large-screen__body {
    height: 100%;
  }
  .body {
    padding-top: 40px;
    padding-left: 24px;
    padding-right: 24px;
    background: white;
  }

  .active {
    font-weight: 700;
    color: white;
    background: $blue;
  }

  .interests-layout {
    justify-content: center;
  }

  .mb-24 {
    margin-bottom: 24px;
  }
  .div-container {
    position: relative;
    background: white;
    height: 100%;
    text-align: center;
    width: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }

  .interests-container {
    width: fit-content;
    height: fit-content;
    color: $blue;
    font-weight: 400;
    border: 1px solid $blue;
    padding:14px;
    border-radius: 24px;
    cursor: pointer;
    margin: 0 2%;
    margin-bottom: 24px;
  }

  .active {
    font-weight: 500;
    color: white;
    background: $blue;
  }

  .title--txt {
    font-size: 24px;
    font-family: MuseoSansRounded-1000;
    padding-right: 16px;
    padding-left: 16px;
    text-transform: uppercase;
  }

  .action-button {
    min-width: 130px;
    max-width: 130px;
    position: fixed;
    bottom: 5px;
    left: calc(50% - 65px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5;
    margin-bottom: 20px;
  }

  @media only screen and (min-width:1600px) {
    .action-button {
      left: calc(50vw + 100px);
    }
  }

  .fixed-primary-button {
    background: $primary;
    font-family: MuseoSans-900;
    text-align: center;
    border-radius: 24px;
    padding: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BrowseInterests.vue